webpackJsonp([56],{

/***/ "DMMP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/page/notfound.vue
//
//
//
//
//
//

/* harmony default export */ var notfound = ({
  mounted: function mounted() {
    var _this = this;

    this.$vux.toast.show({
      type: "text",
      text: "抱歉，该页面不存在！",
      width: "200px"
    });
    setTimeout(function () {
      _this.$router.push("/");
    }, 2000);
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/page/notfound.vue
//
//
//
//
//
//

/* harmony default export */ var page_notfound = ({
  mounted: function mounted() {
    var _this = this;

    this.$vux.toast.show({
      type: "text",
      text: "抱歉，该页面不存在！",
      width: "200px"
    });
    setTimeout(function () {
      _this.$router.push("/");
    }, 2000);
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ac6702de","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/notfound.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_page_notfound = (esExports);
// CONCATENATED MODULE: ./src/page/notfound.vue
function injectStyle (ssrContext) {
  __webpack_require__("l//f")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ac6702de"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  page_notfound,
  selectortype_template_index_0_src_page_notfound,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_page_notfound = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "e7iz":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"notfound.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ "l//f":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("e7iz");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("7c5fb199", content, true, {});

/***/ })

});


// WEBPACK FOOTER //
// static/js/56.f4b9d227965ecd005955.js